import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Стирание символа на клавиатуре суммы — вектор из макета
export function AppIconBackspace({ size = 24, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_TEXT_PRIMARY

  return (
    <Svg width={size} height={size} viewBox="0 0 28 28" fill="none">
      <Path
        fill={fill}
        d="M22.926 9.45438C22.926 8.2491 21.9495 7.27259 20.7442 7.27259H10.9901C10.3371 7.27259 9.7183 7.56459 9.30378 8.06911L5.56889 12.6152C4.90764 13.4202 4.90774 14.5807 5.56889 15.3857L9.30378 19.9331C9.71832 20.4375 10.3372 20.7296 10.9901 20.7296H20.7442C21.9494 20.7296 22.9257 19.7529 22.926 18.5478V9.45438ZM16.7522 10.8596C17.2315 10.3803 18.0084 10.3806 18.4878 10.8596C18.9672 11.339 18.9672 12.1158 18.4878 12.5952L17.0799 14.0018L18.4865 15.4083C18.9657 15.8877 18.9658 16.6646 18.4865 17.1439C18.0071 17.6233 17.2303 17.6232 16.7509 17.1439L15.3443 15.7373L13.9404 17.1439C13.461 17.6233 12.6829 17.6233 12.2035 17.1439C11.7246 16.6646 11.7246 15.8877 12.2035 15.4083L13.6088 14.0018L12.2022 12.5952C11.723 12.1158 11.7229 11.3389 12.2022 10.8596C12.6815 10.3803 13.4583 10.3805 13.9378 10.8596L15.3443 12.2662L16.7522 10.8596ZM25.3822 18.5478C25.3819 21.1089 23.3053 23.1845 20.7442 23.1845H10.9901C9.60228 23.1845 8.28654 22.5638 7.4057 21.4915L3.67215 16.9441C2.26684 15.2334 2.26684 12.7675 3.67215 11.0568L7.4057 6.51069C8.28657 5.43833 9.6023 4.81641 10.9901 4.81641H20.7442C23.3054 4.81641 25.3822 6.89321 25.3822 9.45438V18.5478Z"
      />
    </Svg>
  )
}
